/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * ZEP QUIZ
 * Zep Quiz API
 * OpenAPI spec version: 0.0.1
 */
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';
import { useMutation, useQuery, useSuspenseQuery } from '@tanstack/react-query';

import type { BodyType, ErrorType } from '../../httpClient';
import { httpsInstance } from '../../httpClient';
import type { CreateBoardReq } from '../_model/createBoardReq';
import type { DeleteBoardFileReq } from '../_model/deleteBoardFileReq';
import type { GetMyBoardsParams } from '../_model/getMyBoardsParams';
import type { SuccessBody } from '../_model/successBody';
import type { SuccessBodyBoardDetailRes } from '../_model/successBodyBoardDetailRes';
import type { SuccessBodyBoardRes } from '../_model/successBodyBoardRes';
import type { SuccessBodyBoardShareRes } from '../_model/successBodyBoardShareRes';
import type { SuccessBodyUploadBoardFileRes } from '../_model/successBodyUploadBoardFileRes';
import type { SuccessBodyUploadImageRes } from '../_model/successBodyUploadImageRes';
import type { SuccessBodyZPageBoardSearchRes } from '../_model/successBodyZPageBoardSearchRes';
import type { UpdateBoardReq } from '../_model/updateBoardReq';
import type { UploadBoardFileBody } from '../_model/uploadBoardFileBody';
import type { UploadBoardImageBody } from '../_model/uploadBoardImageBody';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export const createBoard = (
  createBoardReq: BodyType<CreateBoardReq>,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyBoardRes>(
    {
      url: `/boards`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createBoardReq,
      signal,
    },
    options,
  );
};

export const getCreateBoardMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createBoard>>,
    TError,
    { data: BodyType<CreateBoardReq> },
    TContext
  >;
  request?: SecondParameter<typeof httpsInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createBoard>>,
  TError,
  { data: BodyType<CreateBoardReq> },
  TContext
> => {
  const mutationKey = ['createBoard'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createBoard>>,
    { data: BodyType<CreateBoardReq> }
  > = props => {
    const { data } = props ?? {};

    return createBoard(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateBoardMutationResult = NonNullable<
  Awaited<ReturnType<typeof createBoard>>
>;
export type CreateBoardMutationBody = BodyType<CreateBoardReq>;
export type CreateBoardMutationError = ErrorType<unknown>;

export const useCreateBoard = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createBoard>>,
      TError,
      { data: BodyType<CreateBoardReq> },
      TContext
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createBoard>>,
  TError,
  { data: BodyType<CreateBoardReq> },
  TContext
> => {
  const mutationOptions = getCreateBoardMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const updatePlayCount1 = (
  boardId: string,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBody>(
    { url: `/boards/${boardId}/play-count`, method: 'POST', signal },
    options,
  );
};

export const getUpdatePlayCount1MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePlayCount1>>,
    TError,
    { boardId: string },
    TContext
  >;
  request?: SecondParameter<typeof httpsInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updatePlayCount1>>,
  TError,
  { boardId: string },
  TContext
> => {
  const mutationKey = ['updatePlayCount1'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updatePlayCount1>>,
    { boardId: string }
  > = props => {
    const { boardId } = props ?? {};

    return updatePlayCount1(boardId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdatePlayCount1MutationResult = NonNullable<
  Awaited<ReturnType<typeof updatePlayCount1>>
>;

export type UpdatePlayCount1MutationError = ErrorType<unknown>;

export const useUpdatePlayCount1 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updatePlayCount1>>,
      TError,
      { boardId: string },
      TContext
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updatePlayCount1>>,
  TError,
  { boardId: string },
  TContext
> => {
  const mutationOptions = getUpdatePlayCount1MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const uploadBoardImage = (
  boardId: string,
  uploadBoardImageBody: BodyType<UploadBoardImageBody>,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyUploadImageRes>(
    {
      url: `/boards/${boardId}/images`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: uploadBoardImageBody,
      signal,
    },
    options,
  );
};

export const getUploadBoardImageMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uploadBoardImage>>,
    TError,
    { boardId: string; data: BodyType<UploadBoardImageBody> },
    TContext
  >;
  request?: SecondParameter<typeof httpsInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof uploadBoardImage>>,
  TError,
  { boardId: string; data: BodyType<UploadBoardImageBody> },
  TContext
> => {
  const mutationKey = ['uploadBoardImage'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof uploadBoardImage>>,
    { boardId: string; data: BodyType<UploadBoardImageBody> }
  > = props => {
    const { boardId, data } = props ?? {};

    return uploadBoardImage(boardId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UploadBoardImageMutationResult = NonNullable<
  Awaited<ReturnType<typeof uploadBoardImage>>
>;
export type UploadBoardImageMutationBody = BodyType<UploadBoardImageBody>;
export type UploadBoardImageMutationError = ErrorType<unknown>;

export const useUploadBoardImage = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof uploadBoardImage>>,
      TError,
      { boardId: string; data: BodyType<UploadBoardImageBody> },
      TContext
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof uploadBoardImage>>,
  TError,
  { boardId: string; data: BodyType<UploadBoardImageBody> },
  TContext
> => {
  const mutationOptions = getUploadBoardImageMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const uploadBoardFile = (
  boardId: string,
  uploadBoardFileBody: BodyType<UploadBoardFileBody>,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyUploadBoardFileRes>(
    {
      url: `/boards/${boardId}/files`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: uploadBoardFileBody,
      signal,
    },
    options,
  );
};

export const getUploadBoardFileMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uploadBoardFile>>,
    TError,
    { boardId: string; data: BodyType<UploadBoardFileBody> },
    TContext
  >;
  request?: SecondParameter<typeof httpsInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof uploadBoardFile>>,
  TError,
  { boardId: string; data: BodyType<UploadBoardFileBody> },
  TContext
> => {
  const mutationKey = ['uploadBoardFile'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof uploadBoardFile>>,
    { boardId: string; data: BodyType<UploadBoardFileBody> }
  > = props => {
    const { boardId, data } = props ?? {};

    return uploadBoardFile(boardId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UploadBoardFileMutationResult = NonNullable<
  Awaited<ReturnType<typeof uploadBoardFile>>
>;
export type UploadBoardFileMutationBody = BodyType<UploadBoardFileBody>;
export type UploadBoardFileMutationError = ErrorType<unknown>;

export const useUploadBoardFile = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof uploadBoardFile>>,
      TError,
      { boardId: string; data: BodyType<UploadBoardFileBody> },
      TContext
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof uploadBoardFile>>,
  TError,
  { boardId: string; data: BodyType<UploadBoardFileBody> },
  TContext
> => {
  const mutationOptions = getUploadBoardFileMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const deleteBoardFile = (
  boardId: string,
  deleteBoardFileReq: BodyType<DeleteBoardFileReq>,
  options?: SecondParameter<typeof httpsInstance>,
) => {
  return httpsInstance<SuccessBody>(
    {
      url: `/boards/${boardId}/files`,
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json' },
      data: deleteBoardFileReq,
    },
    options,
  );
};

export const getDeleteBoardFileMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteBoardFile>>,
    TError,
    { boardId: string; data: BodyType<DeleteBoardFileReq> },
    TContext
  >;
  request?: SecondParameter<typeof httpsInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteBoardFile>>,
  TError,
  { boardId: string; data: BodyType<DeleteBoardFileReq> },
  TContext
> => {
  const mutationKey = ['deleteBoardFile'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteBoardFile>>,
    { boardId: string; data: BodyType<DeleteBoardFileReq> }
  > = props => {
    const { boardId, data } = props ?? {};

    return deleteBoardFile(boardId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteBoardFileMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteBoardFile>>
>;
export type DeleteBoardFileMutationBody = BodyType<DeleteBoardFileReq>;
export type DeleteBoardFileMutationError = ErrorType<unknown>;

export const useDeleteBoardFile = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteBoardFile>>,
      TError,
      { boardId: string; data: BodyType<DeleteBoardFileReq> },
      TContext
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteBoardFile>>,
  TError,
  { boardId: string; data: BodyType<DeleteBoardFileReq> },
  TContext
> => {
  const mutationOptions = getDeleteBoardFileMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const duplicateBoard = (
  boardId: string,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyBoardRes>(
    { url: `/boards/${boardId}/duplicate`, method: 'POST', signal },
    options,
  );
};

export const getDuplicateBoardMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof duplicateBoard>>,
    TError,
    { boardId: string },
    TContext
  >;
  request?: SecondParameter<typeof httpsInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof duplicateBoard>>,
  TError,
  { boardId: string },
  TContext
> => {
  const mutationKey = ['duplicateBoard'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof duplicateBoard>>,
    { boardId: string }
  > = props => {
    const { boardId } = props ?? {};

    return duplicateBoard(boardId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DuplicateBoardMutationResult = NonNullable<
  Awaited<ReturnType<typeof duplicateBoard>>
>;

export type DuplicateBoardMutationError = ErrorType<unknown>;

export const useDuplicateBoard = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof duplicateBoard>>,
      TError,
      { boardId: string },
      TContext
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof duplicateBoard>>,
  TError,
  { boardId: string },
  TContext
> => {
  const mutationOptions = getDuplicateBoardMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const getBoard = (
  boardId: string,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyBoardDetailRes>(
    { url: `/boards/${boardId}`, method: 'GET', signal },
    options,
  );
};

export const getGetBoardQueryKey = (boardId: string) => {
  return [`/boards/${boardId}`] as const;
};

export const getGetBoardQueryOptions = <
  TData = Awaited<ReturnType<typeof getBoard>>,
  TError = ErrorType<unknown>,
>(
  boardId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBoard>>, TError, TData>
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetBoardQueryKey(boardId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getBoard>>> = ({
    signal,
  }) => getBoard(boardId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!boardId,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getBoard>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData>;
  };
};

export type GetBoardQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBoard>>
>;
export type GetBoardQueryError = ErrorType<unknown>;

export function useGetBoard<
  TData = Awaited<ReturnType<typeof getBoard>>,
  TError = ErrorType<unknown>,
>(
  boardId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBoard>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBoard>>,
          TError,
          Awaited<ReturnType<typeof getBoard>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetBoard<
  TData = Awaited<ReturnType<typeof getBoard>>,
  TError = ErrorType<unknown>,
>(
  boardId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBoard>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBoard>>,
          TError,
          Awaited<ReturnType<typeof getBoard>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetBoard<
  TData = Awaited<ReturnType<typeof getBoard>>,
  TError = ErrorType<unknown>,
>(
  boardId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBoard>>, TError, TData>
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetBoard<
  TData = Awaited<ReturnType<typeof getBoard>>,
  TError = ErrorType<unknown>,
>(
  boardId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBoard>>, TError, TData>
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetBoardQueryOptions(boardId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetBoardSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getBoard>>,
  TError = ErrorType<unknown>,
>(
  boardId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getBoard>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetBoardQueryKey(boardId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getBoard>>> = ({
    signal,
  }) => getBoard(boardId, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getBoard>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetBoardSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBoard>>
>;
export type GetBoardSuspenseQueryError = ErrorType<unknown>;

export function useGetBoardSuspense<
  TData = Awaited<ReturnType<typeof getBoard>>,
  TError = ErrorType<unknown>,
>(
  boardId: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getBoard>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetBoardSuspense<
  TData = Awaited<ReturnType<typeof getBoard>>,
  TError = ErrorType<unknown>,
>(
  boardId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getBoard>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetBoardSuspense<
  TData = Awaited<ReturnType<typeof getBoard>>,
  TError = ErrorType<unknown>,
>(
  boardId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getBoard>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};

export function useGetBoardSuspense<
  TData = Awaited<ReturnType<typeof getBoard>>,
  TError = ErrorType<unknown>,
>(
  boardId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getBoard>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
} {
  const queryOptions = getGetBoardSuspenseQueryOptions(boardId, options);

  const query = useSuspenseQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const deleteBoard = (
  boardId: string,
  options?: SecondParameter<typeof httpsInstance>,
) => {
  return httpsInstance<SuccessBody>(
    { url: `/boards/${boardId}`, method: 'DELETE' },
    options,
  );
};

export const getDeleteBoardMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteBoard>>,
    TError,
    { boardId: string },
    TContext
  >;
  request?: SecondParameter<typeof httpsInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteBoard>>,
  TError,
  { boardId: string },
  TContext
> => {
  const mutationKey = ['deleteBoard'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteBoard>>,
    { boardId: string }
  > = props => {
    const { boardId } = props ?? {};

    return deleteBoard(boardId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteBoardMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteBoard>>
>;

export type DeleteBoardMutationError = ErrorType<unknown>;

export const useDeleteBoard = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteBoard>>,
      TError,
      { boardId: string },
      TContext
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteBoard>>,
  TError,
  { boardId: string },
  TContext
> => {
  const mutationOptions = getDeleteBoardMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const updateBoard = (
  boardId: string,
  updateBoardReq: BodyType<UpdateBoardReq>,
  options?: SecondParameter<typeof httpsInstance>,
) => {
  return httpsInstance<SuccessBodyBoardRes>(
    {
      url: `/boards/${boardId}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: updateBoardReq,
    },
    options,
  );
};

export const getUpdateBoardMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateBoard>>,
    TError,
    { boardId: string; data: BodyType<UpdateBoardReq> },
    TContext
  >;
  request?: SecondParameter<typeof httpsInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateBoard>>,
  TError,
  { boardId: string; data: BodyType<UpdateBoardReq> },
  TContext
> => {
  const mutationKey = ['updateBoard'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateBoard>>,
    { boardId: string; data: BodyType<UpdateBoardReq> }
  > = props => {
    const { boardId, data } = props ?? {};

    return updateBoard(boardId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateBoardMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateBoard>>
>;
export type UpdateBoardMutationBody = BodyType<UpdateBoardReq>;
export type UpdateBoardMutationError = ErrorType<unknown>;

export const useUpdateBoard = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateBoard>>,
      TError,
      { boardId: string; data: BodyType<UpdateBoardReq> },
      TContext
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateBoard>>,
  TError,
  { boardId: string; data: BodyType<UpdateBoardReq> },
  TContext
> => {
  const mutationOptions = getUpdateBoardMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const getShareInfo = (
  boardId: string,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyBoardShareRes>(
    { url: `/boards/${boardId}/share`, method: 'GET', signal },
    options,
  );
};

export const getGetShareInfoQueryKey = (boardId: string) => {
  return [`/boards/${boardId}/share`] as const;
};

export const getGetShareInfoQueryOptions = <
  TData = Awaited<ReturnType<typeof getShareInfo>>,
  TError = ErrorType<unknown>,
>(
  boardId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getShareInfo>>, TError, TData>
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetShareInfoQueryKey(boardId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getShareInfo>>> = ({
    signal,
  }) => getShareInfo(boardId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!boardId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getShareInfo>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetShareInfoQueryResult = NonNullable<
  Awaited<ReturnType<typeof getShareInfo>>
>;
export type GetShareInfoQueryError = ErrorType<unknown>;

export function useGetShareInfo<
  TData = Awaited<ReturnType<typeof getShareInfo>>,
  TError = ErrorType<unknown>,
>(
  boardId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getShareInfo>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getShareInfo>>,
          TError,
          Awaited<ReturnType<typeof getShareInfo>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetShareInfo<
  TData = Awaited<ReturnType<typeof getShareInfo>>,
  TError = ErrorType<unknown>,
>(
  boardId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getShareInfo>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getShareInfo>>,
          TError,
          Awaited<ReturnType<typeof getShareInfo>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetShareInfo<
  TData = Awaited<ReturnType<typeof getShareInfo>>,
  TError = ErrorType<unknown>,
>(
  boardId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getShareInfo>>, TError, TData>
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetShareInfo<
  TData = Awaited<ReturnType<typeof getShareInfo>>,
  TError = ErrorType<unknown>,
>(
  boardId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getShareInfo>>, TError, TData>
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetShareInfoQueryOptions(boardId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetShareInfoSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getShareInfo>>,
  TError = ErrorType<unknown>,
>(
  boardId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getShareInfo>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetShareInfoQueryKey(boardId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getShareInfo>>> = ({
    signal,
  }) => getShareInfo(boardId, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getShareInfo>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetShareInfoSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getShareInfo>>
>;
export type GetShareInfoSuspenseQueryError = ErrorType<unknown>;

export function useGetShareInfoSuspense<
  TData = Awaited<ReturnType<typeof getShareInfo>>,
  TError = ErrorType<unknown>,
>(
  boardId: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getShareInfo>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetShareInfoSuspense<
  TData = Awaited<ReturnType<typeof getShareInfo>>,
  TError = ErrorType<unknown>,
>(
  boardId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getShareInfo>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetShareInfoSuspense<
  TData = Awaited<ReturnType<typeof getShareInfo>>,
  TError = ErrorType<unknown>,
>(
  boardId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getShareInfo>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};

export function useGetShareInfoSuspense<
  TData = Awaited<ReturnType<typeof getShareInfo>>,
  TError = ErrorType<unknown>,
>(
  boardId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getShareInfo>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
} {
  const queryOptions = getGetShareInfoSuspenseQueryOptions(boardId, options);

  const query = useSuspenseQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getMyBoards = (
  params?: GetMyBoardsParams,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyZPageBoardSearchRes>(
    { url: `/boards/my`, method: 'GET', params, signal },
    options,
  );
};

export const getGetMyBoardsQueryKey = (params?: GetMyBoardsParams) => {
  return [`/boards/my`, ...(params ? [params] : [])] as const;
};

export const getGetMyBoardsQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyBoards>>,
  TError = ErrorType<unknown>,
>(
  params?: GetMyBoardsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMyBoards>>, TError, TData>
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMyBoardsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyBoards>>> = ({
    signal,
  }) => getMyBoards(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMyBoards>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetMyBoardsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMyBoards>>
>;
export type GetMyBoardsQueryError = ErrorType<unknown>;

export function useGetMyBoards<
  TData = Awaited<ReturnType<typeof getMyBoards>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | GetMyBoardsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMyBoards>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyBoards>>,
          TError,
          Awaited<ReturnType<typeof getMyBoards>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetMyBoards<
  TData = Awaited<ReturnType<typeof getMyBoards>>,
  TError = ErrorType<unknown>,
>(
  params?: GetMyBoardsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMyBoards>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyBoards>>,
          TError,
          Awaited<ReturnType<typeof getMyBoards>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetMyBoards<
  TData = Awaited<ReturnType<typeof getMyBoards>>,
  TError = ErrorType<unknown>,
>(
  params?: GetMyBoardsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMyBoards>>, TError, TData>
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetMyBoards<
  TData = Awaited<ReturnType<typeof getMyBoards>>,
  TError = ErrorType<unknown>,
>(
  params?: GetMyBoardsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMyBoards>>, TError, TData>
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetMyBoardsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMyBoardsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyBoards>>,
  TError = ErrorType<unknown>,
>(
  params?: GetMyBoardsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMyBoards>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMyBoardsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyBoards>>> = ({
    signal,
  }) => getMyBoards(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMyBoards>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetMyBoardsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMyBoards>>
>;
export type GetMyBoardsSuspenseQueryError = ErrorType<unknown>;

export function useGetMyBoardsSuspense<
  TData = Awaited<ReturnType<typeof getMyBoards>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | GetMyBoardsParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMyBoards>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetMyBoardsSuspense<
  TData = Awaited<ReturnType<typeof getMyBoards>>,
  TError = ErrorType<unknown>,
>(
  params?: GetMyBoardsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMyBoards>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetMyBoardsSuspense<
  TData = Awaited<ReturnType<typeof getMyBoards>>,
  TError = ErrorType<unknown>,
>(
  params?: GetMyBoardsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMyBoards>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};

export function useGetMyBoardsSuspense<
  TData = Awaited<ReturnType<typeof getMyBoards>>,
  TError = ErrorType<unknown>,
>(
  params?: GetMyBoardsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMyBoards>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
} {
  const queryOptions = getGetMyBoardsSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getBoardByEnterCode = (
  enterCode: number,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyBoardDetailRes>(
    { url: `/boards/entry/${enterCode}`, method: 'GET', signal },
    options,
  );
};

export const getGetBoardByEnterCodeQueryKey = (enterCode: number) => {
  return [`/boards/entry/${enterCode}`] as const;
};

export const getGetBoardByEnterCodeQueryOptions = <
  TData = Awaited<ReturnType<typeof getBoardByEnterCode>>,
  TError = ErrorType<unknown>,
>(
  enterCode: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBoardByEnterCode>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetBoardByEnterCodeQueryKey(enterCode);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBoardByEnterCode>>
  > = ({ signal }) => getBoardByEnterCode(enterCode, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!enterCode,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getBoardByEnterCode>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetBoardByEnterCodeQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBoardByEnterCode>>
>;
export type GetBoardByEnterCodeQueryError = ErrorType<unknown>;

export function useGetBoardByEnterCode<
  TData = Awaited<ReturnType<typeof getBoardByEnterCode>>,
  TError = ErrorType<unknown>,
>(
  enterCode: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBoardByEnterCode>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBoardByEnterCode>>,
          TError,
          Awaited<ReturnType<typeof getBoardByEnterCode>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetBoardByEnterCode<
  TData = Awaited<ReturnType<typeof getBoardByEnterCode>>,
  TError = ErrorType<unknown>,
>(
  enterCode: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBoardByEnterCode>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBoardByEnterCode>>,
          TError,
          Awaited<ReturnType<typeof getBoardByEnterCode>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetBoardByEnterCode<
  TData = Awaited<ReturnType<typeof getBoardByEnterCode>>,
  TError = ErrorType<unknown>,
>(
  enterCode: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBoardByEnterCode>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetBoardByEnterCode<
  TData = Awaited<ReturnType<typeof getBoardByEnterCode>>,
  TError = ErrorType<unknown>,
>(
  enterCode: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBoardByEnterCode>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetBoardByEnterCodeQueryOptions(enterCode, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetBoardByEnterCodeSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getBoardByEnterCode>>,
  TError = ErrorType<unknown>,
>(
  enterCode: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getBoardByEnterCode>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetBoardByEnterCodeQueryKey(enterCode);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBoardByEnterCode>>
  > = ({ signal }) => getBoardByEnterCode(enterCode, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getBoardByEnterCode>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetBoardByEnterCodeSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBoardByEnterCode>>
>;
export type GetBoardByEnterCodeSuspenseQueryError = ErrorType<unknown>;

export function useGetBoardByEnterCodeSuspense<
  TData = Awaited<ReturnType<typeof getBoardByEnterCode>>,
  TError = ErrorType<unknown>,
>(
  enterCode: number,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getBoardByEnterCode>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetBoardByEnterCodeSuspense<
  TData = Awaited<ReturnType<typeof getBoardByEnterCode>>,
  TError = ErrorType<unknown>,
>(
  enterCode: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getBoardByEnterCode>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetBoardByEnterCodeSuspense<
  TData = Awaited<ReturnType<typeof getBoardByEnterCode>>,
  TError = ErrorType<unknown>,
>(
  enterCode: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getBoardByEnterCode>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};

export function useGetBoardByEnterCodeSuspense<
  TData = Awaited<ReturnType<typeof getBoardByEnterCode>>,
  TError = ErrorType<unknown>,
>(
  enterCode: number,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getBoardByEnterCode>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
} {
  const queryOptions = getGetBoardByEnterCodeSuspenseQueryOptions(
    enterCode,
    options,
  );

  const query = useSuspenseQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
